import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, childrenPropType, stylePropType } from 'tss-core-lib-common';

var styles = void 0;

var Label = function Label(_ref) {
  var htmlFor = _ref.htmlFor,
      children = _ref.children,
      label = _ref.label,
      labelKey = _ref.labelKey,
      style = _ref.style,
      contentStyle = _ref.contentStyle,
      containerStyle = _ref.containerStyle,
      row = _ref.row,
      succeed = _ref.succeed;

  var labelChild = React.createElement(
    'div',
    {
      className: 'tss-label__contents ' + css(styles.labelText, row && styles.labelTextRow, row && succeed && styles.labelTextRowSucceed, style)
    },
    label || null,
    !label && labelKey ? React.createElement(FormattedMessage, { id: labelKey }) : null
  );

  if (!htmlFor && !children) {
    return labelChild;
  }

  if (!htmlFor) {
    return React.createElement(
      'div',
      {
        className: 'tss-label ' + css(styles.label, row && styles.labelRow, row && succeed && styles.labelRowSucceeding, containerStyle)
      },
      succeed ? null : labelChild,
      React.createElement(
        'div',
        { className: css(styles.children, contentStyle) },
        children
      ),
      succeed ? labelChild : null
    );
  }

  var labelElement = React.createElement(
    'label',
    {
      htmlFor: htmlFor,
      className: 'tss-label ' + css(styles.label, row && succeed && styles.labelRowSucceeding)
    },
    labelChild
  );

  return React.createElement(
    'div',
    { className: css(styles.labelContainer, row && styles.labelContainerRow, containerStyle) },
    succeed ? null : labelElement,
    React.createElement(
      'div',
      { className: css(styles.children, contentStyle) },
      children
    ),
    succeed ? labelElement : null
  );
};

Label.propTypes = {
  htmlFor: PropTypes.string,
  children: childrenPropType,
  label: PropTypes.string,
  labelKey: PropTypes.string,
  style: stylePropType,
  contentStyle: stylePropType,
  containerStyle: stylePropType,
  row: PropTypes.bool,
  succeed: PropTypes.bool
};

Label.defaultProps = {
  htmlFor: null,
  children: null,
  label: null,
  labelKey: null,
  style: null,
  contentStyle: null,
  containerStyle: null,
  row: false,
  succeed: false
};

styles = StyleSheet.create({
  labelContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },

  label: {
    textAlign: 'left'
  },

  labelContainerRow: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  labelText: {
    display: 'block',
    margin: '0 0 1rem 0',
    fontSize: '1.2rem',
    color: TSS_DARK_BLUE(),
    opacity: 0.5,
    textTransform: 'uppercase'
  },

  labelTextRow: {
    margin: '0 1rem 0 0'
  },

  labelTextRowSucceed: {
    margin: '0 0 0 1rem',
    textTransform: 'none',
    fontSize: '1.4rem',
    opacity: 1
  },

  children: {}
});

export default Label;